import posthog from "posthog-js";

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || "https://app.posthog.com";

let isInitialized = false;

export function initPostHog() {
    if (isInitialized || !POSTHOG_KEY) {
        if (!POSTHOG_KEY) {
            console.warn("[PostHog] VITE_POSTHOG_KEY not set, analytics disabled");
        }
        return;
    }

    posthog.init(POSTHOG_KEY, {
        api_host: POSTHOG_HOST,
        capture_pageview: true,
        capture_pageleave: true,
        autocapture: true,
        session_recording: {
            maskAllInputs: true,
            maskTextSelector: "[data-mask]",
        },
        persistence: "localStorage",
        loaded: (ph) => {
            if (import.meta.env.DEV) {
                console.log("[PostHog] Initialized in dev mode");
            }
        },
    });

    isInitialized = true;
}

// Identify user after login
export function identifyUser(userId: string, properties?: Record<string, any>) {
    if (!isInitialized) return;

    posthog.identify(userId, properties);
}

// Reset on logout
export function resetUser() {
    if (!isInitialized) return;

    posthog.reset();
}

// Track custom events
export function trackEvent(eventName: string, properties?: Record<string, any>) {
    if (!isInitialized) return;

    posthog.capture(eventName, properties);
}

// Pre-defined events for Publee
export const analytics = {
    signupCompleted: (method: string) => {
        trackEvent("signup_completed", { method });
    },

    loginCompleted: (method: string) => {
        trackEvent("login_completed", { method });
    },

    taskCreated: (productName: string, type: string) => {
        trackEvent("task_created", { product_name: productName, type });
    },

    taskCompleted: (taskId: string, durationMs: number) => {
        trackEvent("task_completed", { task_id: taskId, duration_ms: durationMs });
    },

    taskFailed: (taskId: string, errorType: string, step: string) => {
        trackEvent("task_failed", { task_id: taskId, error_type: errorType, step });
    },

    creditsPurchased: (amount: number, credits: number) => {
        trackEvent("credits_purchased", { amount_brl: amount, credits_added: credits });
    },

    pageViewed: (path: string, title: string) => {
        trackEvent("page_viewed", { path, title });
    },
};

export { posthog };
